import {getMethod} from '~/api'

async function get(request, cancelToken) {
    return await getMethod('/api/downloadCompanies', request, cancelToken, {responseType: 'arraybuffer'})
}
export {get}
